import React from 'react';
import { Box, Input, Typography } from '@mui/joy';
import LocationPinIcon from '@mui/icons-material/LocationPin';

interface MeetingAddressInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
}

const MeetingAddressInput: React.FC<MeetingAddressInputProps> = ({ value, onChange, error }) => (
  <Box mb={2}>
    <Typography level="body-sm" mb={1}>Meeting Address</Typography>
    <Input
      fullWidth
      value={value}
      onChange={onChange}
      placeholder="Enter address"
      endDecorator={<LocationPinIcon sx={{ color: '#7B7F85' }} />}
      sx={{
        height: 52,
        borderRadius: 12,
        backgroundColor: '#edeff3',
        border: 'none',
        fontSize: 16,
        pl: 2,
        pr: 2,
        boxShadow: 'none',
        '& input': { backgroundColor: 'transparent' },
      }}
      error={!!error}
    />
    {error && (
      <Typography color="danger" level="body-xs" mt={1}>{error}</Typography>
    )}
  </Box>
);

export default MeetingAddressInput; 